/**
 * Simple route helper
 * Maps route names to URLs
 */

const routes = {
    // Dashboard
    'dashboard': '/dashboard',

    // Tickets
    'tickets.index': '/tickets',
    'tickets.calendar': '/tickets/calendar',
    'tickets.create': '/tickets/create',
    'tickets.store': '/tickets',
    'tickets.show': (id) => `/tickets/${id}`,
    'tickets.pdf': (id) => `/tickets/${id}/pdf`,
    'tickets.edit': (id) => `/tickets/${id}/edit`,
    'tickets.update': (id) => `/tickets/${id}`,
    'tickets.destroy': (id) => `/tickets/${id}`,
    'tickets.assign': (id) => `/tickets/${id}/assign`,
    'tickets.reassign': (id) => `/tickets/${id}/reassign`,
    'tickets.updateStatus': (id) => `/tickets/${id}/status`,
    'tickets.updatePriority': (id) => `/tickets/${id}/priority`,
    'tickets.addComment': (id) => `/tickets/${id}/comments`,
    'tickets.uploadFiles': (id) => `/tickets/${id}/upload-files`,
    'tickets.resolve': (id) => `/tickets/${id}/resolve`,
    'tickets.close': (id) => `/tickets/${id}/close`,
    'tickets.reopen': (id) => `/tickets/${id}/reopen`,
    'tickets.merge': (id) => `/tickets/${id}/merge`,
    'tickets.watch': (id) => `/tickets/${id}/watch`,
    'tickets.unwatch': (id) => `/tickets/${id}/watch`,
    'tickets.bulkUpdate': '/tickets/bulk-update',
    'tickets.export': '/tickets/export',
    // Ticket SLA Dashboard
    'tickets.sla-dashboard': '/tickets/sla-dashboard',
    'tickets.sla-dashboard.refresh': '/tickets/sla-dashboard/refresh',
    // Incidents
    'incidents.index': '/incidents',
    'incidents.create': '/incidents/create',
    'incidents.store': '/incidents',
    'incidents.show': (id) => `/incidents/${id}`,
    'incidents.pdf': (id) => `/incidents/${id}/pdf`,
    'incidents.destroy': (id) => `/incidents/${id}`,
    'incidents.triage': (id) => `/incidents/${id}/triage`,
    'incidents.triage.store': (id) => `/incidents/${id}/triage`,
    'incidents.close': (id) => `/incidents/${id}/close`,
    'incidents.reopen': (id) => `/incidents/${id}/reopen`,
    // Quick Fix Actions
    'incidents.quick-fix.change-assignee': (id) => `/incidents/${id}/quick-fix/change-assignee`,
    'incidents.quick-fix.complete': (id) => `/incidents/${id}/quick-fix/complete`,
    'incidents.quick-fix.close': (id) => `/incidents/${id}/quick-fix/close`,
    'incidents.quick-fix.redo': (id) => `/incidents/${id}/quick-fix/redo`,
    // Investigation Routes
    'incidents.investigation.show': (id) => `/incidents/${id}/investigation`,
    'incidents.investigation.start': (id) => `/incidents/${id}/investigation/start`,
    'incidents.investigation.download': (params) => `/incidents/${params.incident}/investigation/items/${params.item}/download`,
    'incidents.investigation.file.delete': (params) => `/incidents/${params.incident}/investigation/items/${params.item}/file`,
    'incidents.investigation.my': '/incidents/my-investigations',
    'incidents.investigation.items.add': (id) => `/incidents/${id}/investigation/items`,
    'incidents.investigation.items.update': (params) => `/incidents/${params.incident}/investigation/items/${params.item}`,
    'incidents.investigation.items.delete': (params) => `/incidents/${params.incident}/investigation/items/${params.item}`,
    'incidents.investigation.root-causes.add': (id) => `/incidents/${id}/investigation/root-causes`,
    'incidents.investigation.root-causes.update': (params) => `/incidents/${params.incident}/investigation/root-causes/${params.rootCause}`,
    'incidents.investigation.root-causes.delete': (params) => `/incidents/${params.incident}/investigation/root-causes/${params.rootCause}`,
    'incidents.investigation.submit': (id) => `/incidents/${id}/investigation/submit`,
    'incidents.investigation.review': (id) => `/incidents/${id}/investigation/review`,
    'incidents.investigation.approve-and-close': (id) => `/incidents/${id}/investigation/approve-and-close`,
    'incidents.investigation.approve': (id) => `/incidents/${id}/investigation/approve`,
    'incidents.investigation.corrective-actions.add': (id) => `/incidents/${id}/corrective-actions/add`,
    'incidents.investigation.change-assignee': (id) => `/incidents/${id}/investigation/change-assignee`,
    'incidents.investigation.addItem': (id) => `/incidents/${id}/investigation/items`,
    'incidents.investigation.addMember': (id) => `/incidents/${id}/investigation/members`,
    'incidents.investigation.removeMember': (id, memberId) => `/incidents/${id}/investigation/members/${memberId}`,
    'incidents.investigation.submitInvestigation': (id) => `/incidents/${id}/investigation/submit`,
    // Corrective Actions
    'incidents.actions.submit': (id) => `/incidents/${id}/actions/submit`,
    'incidents.corrective-actions.change-assignee': (id) => `/incidents/${id}/corrective-actions/change-assignee`,
    'incidents.actions.store': (id) => `/incidents/${id}/actions`,
    'incidents.actions.update': (id, actionId) => `/incidents/${id}/actions/${actionId}`,
    'incidents.actions.destroy': (id, actionId) => `/incidents/${id}/actions/${actionId}`,
    'incidents.actions.start': (id, actionId) => `/incidents/${id}/actions/${actionId}/start`,
    'incidents.actions.complete': (id, actionId) => `/incidents/${id}/actions/${actionId}/complete`,
    'incidents.actions.verify': (id, actionId) => `/incidents/${id}/actions/${actionId}/verify`,
    'incidents.actions.reorder': (id) => `/incidents/${id}/actions/reorder`,
    'incidents.actions.proof.download': (id, actionId) => `/incidents/${id}/actions/${actionId}/proof`,
    'incidents.corrective-actions.create': (id) => `/incidents/${id}/corrective-actions/create`,
    'incidents.corrective-actions.store': (id) => `/incidents/${id}/corrective-actions`,
    'incidents.corrective-actions.assign': (id, actionId) => `/incidents/${id}/corrective-actions/${actionId}/assign`,
    'incidents.corrective-actions.start': (params) => `/incidents/${params.incident}/corrective-actions/${params.action}/start`,
    'incidents.corrective-actions.startWork': (id, actionId) => `/incidents/${id}/corrective-actions/${actionId}/start`,
    'incidents.corrective-actions.complete': (params) => `/incidents/${params.incident}/corrective-actions/${params.action}/complete`,
    'incidents.corrective-actions.verify': (id, actionId) => `/incidents/${id}/corrective-actions/${actionId}/verify`,
    'incidents.corrective-actions.submit-for-review': (id) => `/incidents/${id}/corrective-actions/submit-for-review`,
    'incidents.corrective-actions.require-further-work': (id) => `/incidents/${id}/corrective-actions/require-further-work`,
    'incidents.corrective-actions.approve-and-close': (id) => `/incidents/${id}/corrective-actions/approve-and-close`,
    // Incidents SLA Dashboard
    'incidents.sla-dashboard': '/incidents/sla-dashboard',
    'incidents.sla-dashboard.refresh': '/incidents/sla-dashboard/refresh',
    // External Requests
    'external-requests.index': '/external-requests',
    'external-requests.show': (id) => `/external-requests/${id}`,
    'external-requests.convert-incident': (id) => `/external-requests/${id}/convert-to-incident`,
    'external-requests.convert-work-order': (id) => `/external-requests/${id}/convert-to-work-order`,
    'external-requests.convert-ticket': (id) => `/external-requests/${id}/convert-to-ticket`,
    'external-requests.close': (id) => `/external-requests/${id}/close`,
    'external-requests.lookup-email': '/external-requests/lookup-email',
    // Work Orders
    'work-orders.index': '/work-orders',
    'work-orders.create': '/work-orders/create',
    'work-orders.store': '/work-orders',
    'work-orders.createFromPmSchedule': (scheduleId) => `/work-orders/create-from-pm/${scheduleId}`,
    'work-orders.storeFromPmSchedule': '/work-orders/store-from-pm',
    'work-orders.bulkCreateFromPmSchedules': '/work-orders/bulk-create-from-pm',
    'work-orders.show': (id) => `/work-orders/${id}`,
    'work-orders.pdf': (id) => `/work-orders/${id}/pdf`,
    'work-orders.edit': (id) => `/work-orders/${id}/edit`,
    'work-orders.calendar': '/work-orders/calendar',
    // Work Order Lifecycle
    'work-orders.assign': (id) => `/work-orders/${id}/assign`,
    'work-orders.reassign': (id) => `/work-orders/${id}/reassign`,
    'work-orders.schedule': (id) => `/work-orders/${id}/schedule`,
    'work-orders.start': (id) => `/work-orders/${id}/start`,
    'work-orders.startImmediately': (id) => `/work-orders/${id}/start-immediately`,
    'work-orders.putOnHold': (id) => `/work-orders/${id}/put-on-hold`,
    'work-orders.resume': (id) => `/work-orders/${id}/resume`,
    'work-orders.submitForReview': (id) => `/work-orders/${id}/submit-for-review`,
    'work-orders.complete': (id) => `/work-orders/${id}/complete`,
    'work-orders.cancel': (id) => `/work-orders/${id}/cancel`,
    'work-orders.reopen': (id) => `/work-orders/${id}/reopen`,
    // File & Comments
    'work-orders.uploadFiles': (id) => `/work-orders/${id}/upload-files`,
    'work-orders.addComment': (id) => `/work-orders/${id}/comments`,
    // Cost Tracking
    'work-orders.labor.add': (id) => `/work-orders/${id}/labor`,
    'work-orders.labor.edit': (id, laborId) => `/work-orders/${id}/labor/${laborId}`,
    'work-orders.labor.delete': (id, laborId) => `/work-orders/${id}/labor/${laborId}`,
    'work-orders.material.add': (id) => `/work-orders/${id}/material`,
    'work-orders.material.edit': (id, materialId) => `/work-orders/${id}/material/${materialId}`,
    'work-orders.material.delete': (id, materialId) => `/work-orders/${id}/material/${materialId}`,
    'work-orders.external-repair.add': (id) => `/work-orders/${id}/external-repair`,
    'work-orders.external-repair.edit': (id, repairId) => `/work-orders/${id}/external-repair/${repairId}`,
    'work-orders.external-repair.delete': (id, repairId) => `/work-orders/${id}/external-repair/${repairId}`,
    // Tasks
    'work-orders.tasks.add': (id) => `/work-orders/${id}/tasks`,
    'work-orders.toggle-task': (id, taskId) => `/work-orders/${id}/tasks/${taskId}`,
    'work-orders.tasks.edit': (id, taskId) => `/work-orders/${id}/tasks/${taskId}`,
    'work-orders.tasks.delete': (id, taskId) => `/work-orders/${id}/tasks/${taskId}`,
    // PM Schedules (Maintenance Dashboard)
    'pm-schedules.index': '/pm-schedules',
    // Maintenance SLA Dashboard
    'maintenance.sla-dashboard': '/maintenance/sla-dashboard',
    'maintenance.sla-dashboard.refresh': '/maintenance/sla-dashboard/refresh',
    // Old asset routes (kept for backward compatibility - redirect to new paths)
    'assets.index': '/settings/maintenance/assets',
    'assets.create': '/settings/maintenance/assets/create',
    'assets.store': '/settings/maintenance/assets',
    'assets.show': (id) => `/settings/maintenance/assets/${id}`,
    'assets.edit': (id) => `/settings/maintenance/assets/${id}/edit`,
    'assets.update': (id) => `/settings/maintenance/assets/${id}`,
    'assets.destroy': (id) => `/settings/maintenance/assets/${id}`,
    'assets.qr-code': (id) => `/settings/maintenance/assets/${id}/qr-code`,
    'assets.qrCode': (id) => `/settings/maintenance/assets/${id}/qr-code`,
    'maintenance.reports.data': (filters) => `/maintenance/reports/data?${new URLSearchParams(filters).toString()}`,
    'maintenance.reports.export': (filters) => `/maintenance/reports/export?${new URLSearchParams(filters).toString()}`,
    // Settings
    'settings.index': '/settings',
    'settings.company': '/settings/company',
    'settings.company.edit': '/settings/company/edit',
    'settings.company.update': '/settings/company',
    'settings.company.logo': '/settings/company/logo',
    'settings.company.logo.delete': '/settings/company/logo',
    'settings.company.portal.toggle': '/settings/company/portal/toggle',
    'settings.subscription': '/settings/subscription', // Legacy - redirects to billing
    'settings.billing.index': '/settings/billing',
    'settings.billing.invoices': '/settings/billing/invoices',
    'settings.billing.download-invoice': (invoiceId) => `/settings/billing/invoices/${invoiceId}/download`,
    'settings.billing.portal': '/settings/billing/portal',
    'settings.billing.update-info': '/settings/billing/info',
    'settings.billing.cancel-subscription': '/settings/billing/subscription/cancel',
    'settings.billing.resume-subscription': '/settings/billing/subscription/resume',
    'settings.billing.cancel-scheduled-change': '/settings/billing/subscription/cancel-scheduled-change',
    'settings.subscription.change-plan': '/settings/subscription/change-plan',
    // Payment Methods
    'settings.billing.payment-methods.index': '/settings/billing/payment-methods',
    'settings.billing.payment-methods.create': '/settings/billing/payment-methods/create',
    'settings.billing.payment-methods.store': '/settings/billing/payment-methods',
    'settings.billing.payment-methods.set-default': (id) => `/settings/billing/payment-methods/${id}/set-default`,
    'settings.billing.payment-methods.destroy': (id) => `/settings/billing/payment-methods/${id}`,
    'settings.modules': '/settings/modules',
    'settings.roles.index': '/settings/roles',
    'settings.roles.create': '/settings/roles/create',
    'settings.roles.edit': (id) => `/settings/roles/${id}/edit`,
    'settings.permissions.matrix': '/settings/permissions/matrix',
    // Tickets Settings
    'settings.tickets.index': '/settings/tickets',
    // Ticket Categories
    'settings.tickets.categories.index': '/settings/tickets/categories',
    'settings.tickets.categories.create': '/settings/tickets/categories/create',
    'settings.tickets.categories.store': '/settings/tickets/categories',
    'settings.tickets.categories.edit': (id) => `/settings/tickets/categories/${id}/edit`,
    'settings.tickets.categories.update': (id) => `/settings/tickets/categories/${id}`,
    'settings.tickets.categories.destroy': (id) => `/settings/tickets/categories/${id}`,
    'settings.tickets.categories.toggleActive': (id) => `/settings/tickets/categories/${id}/toggle-active`,
    // Ticket SLA Policies
    'settings.tickets.sla.index': '/settings/tickets/sla',
    'settings.tickets.sla.create': '/settings/tickets/sla/create',
    'settings.tickets.sla.store': '/settings/tickets/sla',
    'settings.tickets.sla.edit': (id) => `/settings/tickets/sla/${id}/edit`,
    'settings.tickets.sla.update': (id) => `/settings/tickets/sla/${id}`,
    'settings.tickets.sla.destroy': (id) => `/settings/tickets/sla/${id}`,
    'settings.tickets.sla.toggleActive': (id) => `/settings/tickets/sla/${id}/toggle-active`,
    // Ticket SLA Digest Configuration
    'settings.settings.tickets.sla.sla-digest.store': '/settings/tickets/sla/sla-digest',
    'settings.settings.tickets.sla.sla-digest.test': '/settings/tickets/sla/sla-digest/test',
    // Ticket Notification Policies
    'settings.tickets.notification-policies.index': '/settings/tickets/notification-policies',
    'settings.tickets.notification-policies.create': '/settings/tickets/notification-policies/create',
    'settings.tickets.notification-policies.store': '/settings/tickets/notification-policies',
    'settings.tickets.notification-policies.show': (id) => `/settings/tickets/notification-policies/${id}`,
    'settings.tickets.notification-policies.edit': (id) => `/settings/tickets/notification-policies/${id}/edit`,
    'settings.tickets.notification-policies.update': (id) => `/settings/tickets/notification-policies/${id}`,
    'settings.tickets.notification-policies.destroy': (id) => `/settings/tickets/notification-policies/${id}`,
    // Maintenance Settings
    'settings.maintenance.index': '/settings/maintenance',
    'settings.maintenance.service-categories.index': '/settings/maintenance/service-categories',
    'settings.maintenance.service-categories.create': '/settings/maintenance/service-categories/create',
    'settings.maintenance.service-categories.edit': (id) => `/settings/maintenance/service-categories/${id}/edit`,
    'settings.maintenance.service-categories.store': '/settings/maintenance/service-categories',
    'settings.maintenance.service-categories.update': (id) => `/settings/maintenance/service-categories/${id}`,
    'settings.maintenance.service-categories.destroy': (id) => `/settings/maintenance/service-categories/${id}`,
    'settings.maintenance.service-categories.toggleActive': (id) => `/settings/maintenance/service-categories/${id}/toggle-active`,
    'settings.maintenance.services.index': '/settings/maintenance/services',
    'settings.maintenance.services.create': '/settings/maintenance/services/create',
    'settings.maintenance.services.edit': (id) => `/settings/maintenance/services/${id}/edit`,
    'settings.maintenance.services.store': '/settings/maintenance/services',
    'settings.maintenance.services.update': (id) => `/settings/maintenance/services/${id}`,
    'settings.maintenance.services.destroy': (id) => `/settings/maintenance/services/${id}`,
    'settings.maintenance.services.toggleActive': (id) => `/settings/maintenance/services/${id}/toggle-active`,
    'settings.maintenance.sla-policies.index': '/settings/maintenance/sla-policies',
    'settings.maintenance.sla-policies.create': '/settings/maintenance/sla-policies/create',
    'settings.maintenance.sla-policies.edit': (id) => `/settings/maintenance/sla-policies/${id}/edit`,
    'settings.maintenance.sla-policies.store': '/settings/maintenance/sla-policies',
    'settings.maintenance.sla-policies.update': (id) => `/settings/maintenance/sla-policies/${id}`,
    'settings.maintenance.sla-policies.destroy': (id) => `/settings/maintenance/sla-policies/${id}`,
    'settings.maintenance.sla-policies.toggleActive': (id) => `/settings/maintenance/sla-policies/${id}/toggle-active`,
    // SLA Digest Configuration
    'settings.maintenance.sla-digest.store': '/settings/maintenance/sla-digest',
    'settings.maintenance.sla-digest.test': '/settings/maintenance/sla-digest/test',
    // Work Order Notification Policies
    'settings.maintenance.notification-policies.index': '/settings/maintenance/notification-policies',
    'settings.maintenance.notification-policies.create': '/settings/maintenance/notification-policies/create',
    'settings.maintenance.notification-policies.show': (id) => `/settings/maintenance/notification-policies/${id}`,
    'settings.maintenance.notification-policies.edit': (id) => `/settings/maintenance/notification-policies/${id}/edit`,
    'settings.maintenance.notification-policies.store': '/settings/maintenance/notification-policies',
    'settings.maintenance.notification-policies.update': (id) => `/settings/maintenance/notification-policies/${id}`,
    'settings.maintenance.notification-policies.destroy': (id) => `/settings/maintenance/notification-policies/${id}`,
    'settings.maintenance.notification-policies.toggleActive': (id) => `/settings/maintenance/notification-policies/${id}/toggle-active`,
    'settings.maintenance.assets.index': '/settings/maintenance/assets',
    'settings.maintenance.assets.create': '/settings/maintenance/assets/create',
    'settings.maintenance.assets.store': '/settings/maintenance/assets',
    'settings.maintenance.assets.show': (id) => `/settings/maintenance/assets/${id}`,
    'settings.maintenance.assets.edit': (id) => `/settings/maintenance/assets/${id}/edit`,
    'settings.maintenance.assets.update': (id) => `/settings/maintenance/assets/${id}`,
    'settings.maintenance.assets.destroy': (id) => `/settings/maintenance/assets/${id}`,
    'settings.maintenance.assets.transfer': (id) => `/settings/maintenance/assets/${id}/transfer`,
    'settings.maintenance.assets.retire': (id) => `/settings/maintenance/assets/${id}/retire`,
    'settings.maintenance.assets.qrCode': (id) => `/settings/maintenance/assets/${id}/qr-code`,
    'settings.maintenance.assets.updateMeter': (id) => `/settings/maintenance/assets/${id}/update-meter`,
    'settings.maintenance.assets.maintenanceHistory': (id) => `/settings/maintenance/assets/${id}/maintenance-history`,
    // Asset Categories
    'settings.maintenance.asset-categories.index': '/settings/maintenance/asset-categories',
    'settings.maintenance.asset-categories.store': '/settings/maintenance/asset-categories',
    'settings.maintenance.asset-categories.show': (id) => `/settings/maintenance/asset-categories/${id}`,
    'settings.maintenance.asset-categories.update': (id) => `/settings/maintenance/asset-categories/${id}`,
    'settings.maintenance.asset-categories.destroy': (id) => `/settings/maintenance/asset-categories/${id}`,
    'settings.maintenance.asset-categories.toggleActive': (id) => `/settings/maintenance/asset-categories/${id}/toggle-active`,
    // PM Plans
    'settings.maintenance.pm-plans.index': '/settings/maintenance/pm-plans',
    'settings.maintenance.pm-plans.create': '/settings/maintenance/pm-plans/create',
    'settings.maintenance.pm-plans.show': (id) => `/settings/maintenance/pm-plans/${id}`,
    'settings.maintenance.pm-plans.edit': (id) => `/settings/maintenance/pm-plans/${id}/edit`,
    'settings.maintenance.pm-plans.store': '/settings/maintenance/pm-plans',
    'settings.maintenance.pm-plans.update': (id) => `/settings/maintenance/pm-plans/${id}`,
    'settings.maintenance.pm-plans.destroy': (id) => `/settings/maintenance/pm-plans/${id}`,
    'settings.maintenance.pm-plans.toggle': (id) => `/settings/maintenance/pm-plans/${id}/toggle`,
    'settings.maintenance.pm-plans.duplicate': (id) => `/settings/maintenance/pm-plans/${id}/duplicate`,
    // PM Schedules
    'settings.maintenance.pm-schedules.index': '/settings/maintenance/pm-schedules',
    'settings.maintenance.pm-schedules.create': '/settings/maintenance/pm-schedules/create',
    'settings.maintenance.pm-schedules.store': '/settings/maintenance/pm-schedules',
    'settings.maintenance.pm-schedules.show': (id) => `/settings/maintenance/pm-schedules/${id}`,
    'settings.maintenance.pm-schedules.edit': (id) => `/settings/maintenance/pm-schedules/${id}/edit`,
    'settings.maintenance.pm-schedules.update': (id) => `/settings/maintenance/pm-schedules/${id}`,
    'settings.maintenance.pm-schedules.destroy': (id) => `/settings/maintenance/pm-schedules/${id}`,
    'settings.maintenance.pm-schedules.toggle': (id) => `/settings/maintenance/pm-schedules/${id}/toggle`,
    'settings.maintenance.pm-schedules.generateWorkOrder': (id) => `/settings/maintenance/pm-schedules/${id}/generate-work-order`,
    // Locations
    'settings.locations.index': '/settings/locations',
    'settings.locations.create': '/settings/locations/create',
    'settings.locations.store': '/settings/locations',
    'settings.locations.show': (id) => `/settings/locations/${id}`,
    'settings.locations.edit': (id) => `/settings/locations/${id}/edit`,
    'settings.locations.update': (id) => `/settings/locations/${id}`,
    'settings.locations.destroy': (id) => `/settings/locations/${id}`,
    'settings.locations.toggleActive': (id) => `/settings/locations/${id}/toggle-active`,
    'settings.locations.assignUser': (id) => `/settings/locations/${id}/assign-user`,
    'settings.locations.unassignUser': (id, assignmentId) => `/settings/locations/${id}/unassign-user/${assignmentId}`,
    'settings.locations.checkParentAssignment': '/settings/locations/check-parent-assignment',
    // Incident Settings
    'settings.incidents.index': '/settings/incidents',
    // Incident Types
    'settings.incidents.types.index': '/settings/incidents/types',
    'settings.incidents.types.create': '/settings/incidents/types/create',
    'settings.incidents.types.store': '/settings/incidents/types',
    'settings.incidents.types.show': (id) => `/settings/incidents/types/${id}`,
    'settings.incidents.types.edit': (id) => `/settings/incidents/types/${id}/edit`,
    'settings.incidents.types.update': (id) => `/settings/incidents/types/${id}`,
    'settings.incidents.types.destroy': (id) => `/settings/incidents/types/${id}`,
    'settings.incidents.types.reorder': '/settings/incidents/types/reorder',
    'settings.incidents.types.toggle': (id) => `/settings/incidents/types/${id}/toggle`,
    'settings.incidents.types.duplicate': (id) => `/settings/incidents/types/${id}/duplicate`,
    // Incident Notification Policies
    'settings.incidents.notification-policies.index': '/settings/incidents/notification-policies',
    'settings.incidents.notification-policies.create': '/settings/incidents/notification-policies/create',
    'settings.incidents.notification-policies.store': '/settings/incidents/notification-policies',
    'settings.incidents.notification-policies.show': (id) => `/settings/incidents/notification-policies/${id}`,
    'settings.incidents.notification-policies.edit': (id) => `/settings/incidents/notification-policies/${id}/edit`,
    'settings.incidents.notification-policies.update': (id) => `/settings/incidents/notification-policies/${id}`,
    'settings.incidents.notification-policies.destroy': (id) => `/settings/incidents/notification-policies/${id}`,
    'settings.incidents.notification-policies.reorder': '/settings/incidents/notification-policies/reorder',
    'settings.incidents.notification-policies.toggle': (id) => `/settings/incidents/notification-policies/${id}/toggle`,
    'settings.incidents.notification-policies.duplicate': (id) => `/settings/incidents/notification-policies/${id}/duplicate`,
    'settings.incidents.notification-policies.test': (id) => `/settings/incidents/notification-policies/${id}/test`,
    // Incident SLA Policies
    'settings.incidents.sla-policies.index': '/settings/incidents/sla-policies',
    'settings.incidents.sla-policies.create': '/settings/incidents/sla-policies/create',
    'settings.incidents.sla-policies.store': '/settings/incidents/sla-policies',
    'settings.incidents.sla-policies.show': (id) => `/settings/incidents/sla-policies/${id}`,
    'settings.incidents.sla-policies.edit': (id) => `/settings/incidents/sla-policies/${id}/edit`,
    'settings.incidents.sla-policies.update': (id) => `/settings/incidents/sla-policies/${id}`,
    'settings.incidents.sla-policies.destroy': (id) => `/settings/incidents/sla-policies/${id}`,
    'settings.incidents.sla-policies.toggle-active': (id) => `/settings/incidents/sla-policies/${id}/toggle-active`,
    'settings.incidents.sla-policies.test-match': '/settings/incidents/sla-policies/test-match',
    // Incident SLA Digest Configuration
    'settings.incidents.sla-digest.store': '/settings/incidents/sla-digest',
    'settings.incidents.sla-digest.test': '/settings/incidents/sla-digest/test',
    // Team
    'team.index': '/team',
    'team.roles.index': '/team/roles',
    'team.invite': '/team/invite',
    'team.invitation.resend': (id) => `/team/invitation/${id}/resend`,
    'team.invitation.cancel': (id) => `/team/invitation/${id}`,
    'team.member.personal-info': (userId) => `/team/member/${userId}/personal-info`,
    'team.member.roles': (userId) => `/team/member/${userId}/roles`,
    'team.member.status': (userId) => `/team/member/${userId}/status`,
    'team.member.remove': (userId) => `/team/member/${userId}`,
    'team.invitation.accept': (token) => `/accept-invitation/${token}`,
    // Search
    'search': '/search',
    'search.suggestions': '/search/suggestions',
    // Profile
    'profile.show': '/profile',
    'profile.edit': '/profile/edit',
    'profile.update': '/profile',
    'profile.email.update': '/profile/email',
    'profile.password': '/profile/password',
    'profile.password.update': '/profile/password',
    'profile.photo.upload': '/profile/photo',
    'profile.photo.delete': '/profile/photo',
    'profile.sessions': '/profile/sessions',
    'profile.sessions.revoke': (id) => `/profile/sessions/${id}`,
    'profile.sessions.revoke-all': '/profile/sessions',
    'profile.security': '/profile/security',
    'profile.2fa.enable': '/profile/2fa/enable',
    'profile.2fa.confirm': '/profile/2fa/confirm',
    'profile.2fa.disable': '/profile/2fa/disable',
    'profile.2fa.backup-codes': '/profile/2fa/backup-codes',
    'profile.2fa.backup-codes.regenerate': '/profile/2fa/backup-codes/regenerate',
    'profile.trusted-devices.index': '/profile/trusted-devices',
    'profile.trusted-devices.revoke': (id) => `/profile/trusted-devices/${id}`,
    'profile.trusted-devices.revoke-all': '/profile/trusted-devices',
    // Company Switching
    'company.switch': (id) => `/switch-company/${id}`,
    'company.select': '/select-company',
    'companies.available': '/companies/available',
    // Company Management
    'add-first-company': '/add-first-company',
    'company.create': '/company/create',
    'company.store': '/company/create',
    'my-companies.index': '/my-companies',
    // Ticket Task Management
    'tickets.tasks.add': (ticketId) => `/tickets/${ticketId}/tasks`,
    'tickets.toggle-task': (ticketId, taskId) => `/tickets/${ticketId}/tasks/${taskId}`,
    'tickets.tasks.edit': (ticketId, taskId) => `/tickets/${ticketId}/tasks/${taskId}`,
    'tickets.tasks.delete': (ticketId, taskId) => `/tickets/${ticketId}/tasks/${taskId}`,
    'tickets.tasks.complete': (ticketId, taskId) => `/tickets/${ticketId}/tasks/${taskId}/complete`,
    'tickets.tasks.uncomplete': (ticketId, taskId) => `/tickets/${ticketId}/tasks/${taskId}/uncomplete`,
    // Ticket Labor Tracking
    'tickets.labor.add': (ticketId) => `/tickets/${ticketId}/labor`,
    'tickets.labor.update': (ticketId, laborId) => `/tickets/${ticketId}/labor/${laborId}`,
    'tickets.labor.delete': (ticketId, laborId) => `/tickets/${ticketId}/labor/${laborId}`,
    // Ticket Material Tracking
    'tickets.materials.add': (ticketId) => `/tickets/${ticketId}/materials`,
    'tickets.materials.update': (ticketId, materialId) => `/tickets/${ticketId}/materials/${materialId}`,
    'tickets.materials.delete': (ticketId, materialId) => `/tickets/${ticketId}/materials/${materialId}`,
    // Ticket External Repair Tracking
    'tickets.external-repairs.add': (ticketId) => `/tickets/${ticketId}/external-repairs`,
    'tickets.external-repairs.update': (ticketId, repairId) => `/tickets/${ticketId}/external-repairs/${repairId}`,
    'tickets.external-repairs.delete': (ticketId, repairId) => `/tickets/${ticketId}/external-repairs/${repairId}`,
    // Ticket Scheduling
    'tickets.schedule': (ticketId) => `/tickets/${ticketId}/schedule`,
    // Ticket Workflow
    'tickets.start': (ticketId) => `/tickets/${ticketId}/start`,
    'tickets.putOnHold': (ticketId) => `/tickets/${ticketId}/put-on-hold`,
    'tickets.resume': (ticketId) => `/tickets/${ticketId}/resume`,
    'tickets.complete': (ticketId) => `/tickets/${ticketId}/complete`,
    'tickets.cancel': (ticketId) => `/tickets/${ticketId}/cancel`,
    'tickets.close': (ticketId) => `/tickets/${ticketId}/close`,
    // IT Equipment
    'it-equipment.index': '/settings/it-equipment',
    'it-equipment.create': '/settings/it-equipment/create',
    'it-equipment.store': '/settings/it-equipment',
    'it-equipment.show': (id) => `/settings/it-equipment/${id}`,
    'it-equipment.edit': (id) => `/settings/it-equipment/${id}/edit`,
    'it-equipment.update': (id) => `/settings/it-equipment/${id}`,
    'it-equipment.destroy': (id) => `/settings/it-equipment/${id}`,
    'it-equipment.assign-user': (id) => `/settings/it-equipment/${id}/assign-user`,
    'it-equipment.remove-user': (id) => `/settings/it-equipment/${id}/remove-user`,
    'it-equipment.update-user-role': (id) => `/settings/it-equipment/${id}/update-user-role`,
    'it-equipment.transfer': (id) => `/settings/it-equipment/${id}/transfer`,
    'it-equipment.change-status': (id) => `/settings/it-equipment/${id}/change-status`,
    // IT Equipment Categories
    'it-equipment-categories.index': '/settings/it-equipment-categories',
    'it-equipment-categories.create': '/settings/it-equipment-categories/create',
    'it-equipment-categories.store': '/settings/it-equipment-categories',
    'it-equipment-categories.edit': (id) => `/settings/it-equipment-categories/${id}/edit`,
    'it-equipment-categories.update': (id) => `/settings/it-equipment-categories/${id}`,
    'it-equipment-categories.destroy': (id) => `/settings/it-equipment-categories/${id}`,
    // Ticket Notification Policies
    'ticket-notification-policies.index': '/settings/tickets/notification-policies',
    'ticket-notification-policies.create': '/settings/tickets/notification-policies/create',
    'ticket-notification-policies.store': '/settings/tickets/notification-policies',
    'ticket-notification-policies.show': (id) => `/settings/tickets/notification-policies/${id}`,
    'ticket-notification-policies.edit': (id) => `/settings/tickets/notification-policies/${id}/edit`,
    'ticket-notification-policies.update': (id) => `/settings/tickets/notification-policies/${id}`,
    'ticket-notification-policies.destroy': (id) => `/settings/tickets/notification-policies/${id}`,
    'ticket-notification-policies.toggleActive': (id) => `/settings/tickets/notification-policies/${id}/toggle-active`,
    // Old routes (kept for backward compatibility)
    'settings.service-categories.index': '/settings/maintenance/service-categories',
    'settings.service-categories.create': '/settings/maintenance/service-categories/create',
    'settings.service-categories.edit': (id) => `/settings/maintenance/service-categories/${id}/edit`,
    'settings.services.index': '/settings/maintenance/services',
    'settings.services.create': '/settings/maintenance/services/create',
    'settings.services.edit': (id) => `/settings/maintenance/services/${id}/edit`,
    'settings.sla-policies.index': '/settings/maintenance/sla-policies',
    'settings.sla-policies.create': '/settings/maintenance/sla-policies/create',
    'settings.sla-policies.edit': (id) => `/settings/maintenance/sla-policies/${id}/edit`,
    // API Routes - Billing
    'api.settings.billing.retry-payment': '/api/settings/billing/retry-payment',
    'api.settings.billing.change-plan': '/api/settings/billing/change-plan',
    'api.settings.billing.purchase-addon': '/api/settings/billing/purchase-addon',
    'api.settings.billing.remove-addon': (addonId) => `/api/settings/billing/remove-addon/${addonId}`,
    // Password Reset
    'password.request': '/forgot-password',
    'password.email': '/forgot-password',
    'password.reset': (token) => `/reset-password/${token}`,
    'password.update': '/reset-password',
    // Reports
    'reports.index': '/reports',
    'reports.export': (params) => `/reports/export?${new URLSearchParams(params).toString()}`,
    // Maintenance Reports
    'reports.maintenance.index': '/reports/maintenance',
    'reports.maintenance.work-order-status': '/reports/maintenance/work-order-status',
    'reports.maintenance.work-order-status.generate': '/reports/maintenance/work-order-status/generate',
    'reports.maintenance.expenditure': '/reports/maintenance/expenditure',
    'reports.maintenance.expenditure.generate': '/reports/maintenance/expenditure/generate',
    'reports.maintenance.statistics': '/reports/maintenance/statistics',
    'reports.maintenance.statistics.load': '/reports/maintenance/statistics/load',
    'reports.maintenance.export-pdf': '/reports/maintenance/export-pdf',
    'reports.maintenance.export-csv': '/reports/maintenance/export-csv',
    // Ticket Reports (Helpdesk)
    'reports.tickets.index': '/reports/tickets',
    'reports.tickets.ticket-status': '/reports/tickets/ticket-status',
    'reports.tickets.ticket-status.generate': '/reports/tickets/ticket-status/generate',
    'reports.tickets.expenditure': '/reports/tickets/expenditure',
    'reports.tickets.expenditure.generate': '/reports/tickets/expenditure/generate',
    'reports.tickets.statistics': '/reports/tickets/statistics',
    'reports.tickets.statistics.load': '/reports/tickets/statistics/load',
    'reports.tickets.export-pdf': '/reports/tickets/export-pdf',
    'reports.tickets.export-csv': '/reports/tickets/export-csv',
    // Incident Reports
    'reports.incidents.index': '/reports/incidents',
    'reports.incidents.incident-status': '/reports/incidents/incident-status',
    'reports.incidents.incident-status.data': '/reports/incidents/incident-status/data',
    'reports.incidents.incident-status.pdf': '/reports/incidents/incident-status/pdf',
    'reports.incidents.incident-status.csv': '/reports/incidents/incident-status/csv',
    'reports.incidents.statistics': '/reports/incidents/statistics',
    // Checklist Reports (Inspection)
    'reports.checklists.index': '/reports/checklists',
    'reports.checklists.checklist-status': '/reports/checklists/checklist-status',
    'reports.checklists.checklist-status.generate': '/reports/checklists/checklist-status/generate',
    'reports.checklists.responses-summary': '/reports/checklists/responses-summary',
    'reports.checklists.responses-summary.generate': '/reports/checklists/responses-summary/generate',
    'reports.checklists.responses-detailed': '/reports/checklists/responses-detailed',
    'reports.checklists.responses-detailed.generate': '/reports/checklists/responses-detailed/generate',
    'reports.checklists.responses-detailed.locations': '/reports/checklists/responses-detailed/locations',
    'reports.checklists.responses-detailed.assets': '/reports/checklists/responses-detailed/assets',
    'reports.checklists.responses-comparison-by-location': '/reports/checklists/responses-comparison-by-location',
    'reports.checklists.responses-comparison-by-location.generate': '/reports/checklists/responses-comparison-by-location/generate',
    'reports.checklists.responses-comparison-by-location.export-csv': '/reports/checklists/responses-comparison-by-location/export-csv',
    'reports.checklists.export-pdf': '/reports/checklists/export-pdf',
    'reports.checklists.export-csv': '/reports/checklists/export-csv',
    // Checklists
    'checklists.index': '/checklists',
    // 'checklists.my-tasks': '/checklists/my-tasks', // Disabled - ToDo/Pending page
    'checklists.performance': '/checklists/performance',
    'checklists.performance.load': '/checklists/performance/load',
    'checklists.performance.export-pdf': '/checklists/performance/export-pdf',
    'checklists.create': '/checklists/create',
    'checklists.store': '/checklists',
    'checklists.show': (id) => `/checklists/${id}`,
    'checklists.destroy': (id) => `/checklists/${id}`,
    'checklists.start': (id) => `/checklists/${id}/start`,
    'checklists.conduct': (id) => `/checklists/${id}/conduct`,
    'checklists.save-response': (id) => `/checklists/${id}/save-response`,
    'checklists.submit': (id) => `/checklists/${id}/submit`,
    'checklists.add-comment': (id) => `/checklists/${id}/comments`,
    // Checklist Templates
    'checklists.templates.index': '/checklists/templates',
    'checklists.templates.create': '/checklists/templates/create',
    'checklists.templates.store': '/checklists/templates',
    'checklists.templates.show': (id) => `/checklists/templates/${id}`,
    'checklists.templates.edit': (id) => `/checklists/templates/${id}/edit`,
    'checklists.templates.update': (id) => `/checklists/templates/${id}`,
    'checklists.templates.destroy': (id) => `/checklists/templates/${id}`,
    'checklists.templates.publish': (id) => `/checklists/templates/${id}/publish`,
    'checklists.templates.duplicate': (id) => `/checklists/templates/${id}/duplicate`,
    'checklists.templates.deactivate': (id) => `/checklists/templates/${id}/deactivate`,
    // Template Builder API
    'checklists.templates.sections.store': (id) => `/checklists/templates/${id}/sections`,
    'checklists.templates.sections.update': (templateId, sectionId) => `/checklists/templates/${templateId}/sections/${sectionId}`,
    'checklists.templates.sections.destroy': (templateId, sectionId) => `/checklists/templates/${templateId}/sections/${sectionId}`,
    'checklists.templates.sections.reorder': (id) => `/checklists/templates/${id}/sections/reorder`,
    'checklists.templates.fields.store': (id) => `/checklists/templates/${id}/fields`,
    'checklists.templates.fields.update': (templateId, fieldId) => `/checklists/templates/${templateId}/fields/${fieldId}`,
    'checklists.templates.fields.destroy': (templateId, fieldId) => `/checklists/templates/${templateId}/fields/${fieldId}`,
    'checklists.templates.fields.reorder': (id) => `/checklists/templates/${id}/fields/reorder`,
    // Checklist Schedules
    'checklists.schedules.index': '/checklists/schedules',
    'checklists.schedules.create': '/checklists/schedules/create',
    'checklists.schedules.store': '/checklists/schedules',
    'checklists.schedules.show': (id) => `/checklists/schedules/${id}`,
    'checklists.schedules.edit': (id) => `/checklists/schedules/${id}/edit`,
    'checklists.schedules.update': (id) => `/checklists/schedules/${id}`,
    'checklists.schedules.destroy': (id) => `/checklists/schedules/${id}`,
    'checklists.schedules.pause': (id) => `/checklists/schedules/${id}/pause`,
    'checklists.schedules.resume': (id) => `/checklists/schedules/${id}/resume`,
    // Checklist Workflow
    'checklists.workflow.start-review': (id) => `/checklists/${id}/workflow/start-review`,
    'checklists.workflow.approve': (id) => `/checklists/${id}/workflow/approve`,
    'checklists.workflow.reject': (id) => `/checklists/${id}/workflow/reject`,
    'checklists.workflow.reopen': (id) => `/checklists/${id}/workflow/reopen`,
    'checklists.workflow.cancel': (id) => `/checklists/${id}/workflow/cancel`,
    'checklists.workflow.history': (id) => `/checklists/${id}/workflow/history`,
    // My Tasks
    'my-tasks.index': (params) => {
        if (!params) return '/my-tasks';
        const query = new URLSearchParams(params).toString();
        return query ? `/my-tasks?${query}` : '/my-tasks';
    },

    // Notifications
    'notifications.index': '/notifications',
    'notifications.unread': '/notifications/unread',
    'notifications.markAsRead': (id) => `/notifications/${id}/read`,
    'notifications.read': (id) => `/notifications/${id}/read`,
    'notifications.markAllRead': '/notifications/mark-all-read',
    'notifications.destroy': (id) => `/notifications/${id}`,
    'notifications.destroyAll': '/notifications/all',

    // Site Owner
    'site-owner.login': '/site-owner-administrator/login',
    'site-owner.logout': '/site-owner-administrator/logout',
    'site-owner.dashboard': '/site-owner-administrator/dashboard',
    'site-owner.companies.index': '/site-owner-administrator/companies',
    'site-owner.companies.show': (id) => `/site-owner-administrator/companies/${id}`,
    'site-owner.companies.edit': (id) => `/site-owner-administrator/companies/${id}/edit`,
    'site-owner.companies.create': '/site-owner-administrator/companies/create',
    'site-owner.companies.store': '/site-owner-administrator/companies',
    'site-owner.companies.update': (id) => `/site-owner-administrator/companies/${id}`,
    'site-owner.companies.destroy': (id) => `/site-owner-administrator/companies/${id}`,
    'site-owner.companies.suspend': (id) => `/site-owner-administrator/companies/${id}/suspend`,
    'site-owner.companies.activate': (id) => `/site-owner-administrator/companies/${id}/activate`,
    'site-owner.companies.impersonate': (id) => `/site-owner-administrator/companies/${id}/impersonate`,
    'site-owner.companies.stop-impersonating': '/site-owner-administrator/companies/stop-impersonating',
    'site-owner.users.index': '/site-owner-administrator/users',
    'site-owner.users.show': (id) => `/site-owner-administrator/users/${id}`,
    // Subscription Plans
    'site-owner.subscriptions.plans.index': '/site-owner-administrator/subscriptions/plans',
    'site-owner.subscriptions.plans.create': '/site-owner-administrator/subscriptions/plans/create',
    'site-owner.subscriptions.plans.store': '/site-owner-administrator/subscriptions/plans',
    'site-owner.subscriptions.plans.show': (id) => `/site-owner-administrator/subscriptions/plans/${id}`,
    'site-owner.subscriptions.plans.edit': (id) => `/site-owner-administrator/subscriptions/plans/${id}/edit`,
    'site-owner.subscriptions.plans.update': (id) => `/site-owner-administrator/subscriptions/plans/${id}`,
    'site-owner.subscriptions.plans.destroy': (id) => `/site-owner-administrator/subscriptions/plans/${id}`,
    'site-owner.subscriptions.plans.duplicate': (id) => `/site-owner-administrator/subscriptions/plans/${id}/duplicate`,
    'site-owner.subscriptions.plans.toggle': (id) => `/site-owner-administrator/subscriptions/plans/${id}/toggle`,
    'site-owner.subscriptions.plans.reorder': '/site-owner-administrator/subscriptions/plans/reorder',
    // Plan Features
    'site-owner.subscriptions.plans.features.index': (planId) => `/site-owner-administrator/subscriptions/plans/${planId}/features`,
    'site-owner.subscriptions.plans.features.store': (planId) => `/site-owner-administrator/subscriptions/plans/${planId}/features`,
    'site-owner.subscriptions.plans.features.update': (planId, featureId) => `/site-owner-administrator/subscriptions/plans/${planId}/features/${featureId}`,
    'site-owner.subscriptions.plans.features.destroy': (planId, featureId) => `/site-owner-administrator/subscriptions/plans/${planId}/features/${featureId}`,
    'site-owner.subscriptions.plans.features.bulk-update': (planId) => `/site-owner-administrator/subscriptions/plans/${planId}/features/bulk-update`,
    'site-owner.billing.index': '/site-owner-administrator/billing',
    'site-owner.system.index': '/site-owner-administrator/system',
    'site-owner.settings': '/site-owner-administrator/settings',
};

export function route(name, ...params) {
    const routeValue = routes[name];

    if (!routeValue) {
        console.warn(`Route "${name}" not found`);
        return '/';
    }

    if (typeof routeValue === 'function') {
        return routeValue(...params);
    }

    return routeValue;
}

export default route;
